module.exports = __webpack_public_path__ + "media/videos/onboarding-f31746f9.mp4";